export const checkIsDateWeekend = (date) => date.day() === 6 || date.day() === 0;